import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'jp'],
    defaultNS: 'deals_web',
    ns: ['deals_web'],
    initImmediate: false,
    // backend: {
    //   requestOptions: {
    //     cache: 'force-cache',
    //     expirationTime: 24 * 60 * 60 * 1000,
    //   },
    // },
    react: {
      useSuspense: false,
      wait: true,
    },
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.log(err);
  });

export default i18next;
